import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import GlobalStyles from 'styles/GlobalStyles';
import MainLayout from 'layouts/MainLayout';
import UnifiedLayout from 'layouts/UnifiedLayout';
import { DocExtractor } from 'pages/Playground';
import { Keys, Reference, Usage } from 'pages/Api';
import Home from 'pages/Home';
import Toast from 'components/Toast';
import { useAppDispatch, useAppSelector } from 'store/store';

import { login } from 'store/slices/userInfo';

import { init } from 'util/gaConnect';
import { languageSelector, setLanguage } from 'store/slices/languageSlice';
import i18n from 'locale';
import { initReactI18next } from 'react-i18next';
import Documentation from 'pages/Documentation';

// import * as Sentry from '@sentry/react';
// import { BrowserTracing } from '@sentry/tracing';

i18n.use(initReactI18next).init({
  lng: localStorage.getItem('language') || 'ko',
  fallbackLng: 'ko' // 언어를 찾을 수 없을 때 기본 언어
  // interpolation: {
  //   escapeValue: false
  // }
});

function App() {
  const dispatch = useAppDispatch();
  const lang = useAppSelector(languageSelector);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    i18n.changeLanguage(lang);
    dispatch(setLanguage(lang));
  }, [lang]);

  useEffect(() => {
    fetch(`/api/v1/datainsight/playground/userinfo`)
      .then((res) => res.json())
      .then((res) => {
        try {
          if (res.success === true) {
            const { userName, email, permissions } = res.data;
            dispatch(login({ userName, email, permissions }));
          }
        } catch (e) {}
      });
  }, []);

  //let isSentryInitialized = false; // 중복 초기화를 방지하기 위한 플래그

  // useEffect(() => {
  //   if (!isSentryInitialized) {
  //     Sentry.init({
  //       dsn: 'http://42c8efa745a1ef635dce197d154484c3@43.202.55.200:3000/3',
  //       // integrations: [new BrowserTracing()],

  //       tracesSampleRate: 1.0, // 트랜잭션 추적률 (0~1)
  //       environment: process.env.NODE_ENV, // 환경 정보
  //       sendDefaultPii: true, // PII 데이터 전송 여부

  //       // 세션 리플레이 설정
  //       replaysSessionSampleRate: 0.1, // 전체 세션 중 10% 기록
  //       replaysOnErrorSampleRate: 1.0, // 에러가 발생하면 무조건 기록
  //       integrations: [
  //         Sentry.replayIntegration({
  //           maskAllText: false,
  //           blockAllMedia: false
  //         }) // 세션 리플레이 활성화
  //       ]
  //     });
  //     isSentryInitialized = true; // 초기화 완료 플래그 설정
  //   }
  // }, []);

  return (
    <>
      <GlobalStyles />
      <>
        <Routes>
          <Route
            path="/"
            element={
              <MainLayout>
                <Home />
              </MainLayout>
            }
          />
          <Route
            path="/playground/*"
            element={
              <UnifiedLayout enableScrollTopButton>
                <Routes>
                  <Route index element={<Navigate to="doc-extract" />} />
                  <Route path="doc-extract" element={<DocExtractor />} />
                </Routes>
              </UnifiedLayout>
            }
          />
          <Route
            path="/_api/*"
            element={
              <UnifiedLayout $withSidebar>
                <Routes>
                  <Route index element={<Navigate to="reference" />} />
                  <Route path="reference" element={<Reference />} />
                  <Route path="keys" element={<Keys />} />
                  <Route path="usage" element={<Usage />} />
                </Routes>
              </UnifiedLayout>
            }
          />
          <Route
            path="/documentation"
            element={
              <UnifiedLayout $withSidebar>
                <Documentation />
              </UnifiedLayout>
            }
          />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Toast />
      </>
    </>
  );
}

export default App;

// type ProtectedRouteProps = {
//   children: React.ReactNode;
// };

// const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
//   const { isLogged } = useAppSelector(userInfoSelector);

//   if (!isLogged) {
//     return <Navigate to="/_api/reference" replace />;
//   }

//   return <>{children}</>;
// };
